<ng-container *ngIf="params && params.data && isString(params.value) && params.data.showIcon else value">
	<mat-icon [svgIcon]="params.value" class="copo-datacenter-grid-icon-16"></mat-icon>
</ng-container>
<ng-template #value>
	<span *ngIf="params && isNumber(params.value) && params.data else textValue">{{params.value | copoNumber:'weight'}} &nbsp; {{params.data.unit}}</span>
</ng-template>
<ng-template #textValue>
	<span *ngIf="params">{{params.value}}</span>
</ng-template>